import a from "moment";
import o from "../time/getTimeSpanParts.mjs";
import p from "./hoursAndMinutesToMinutes.mjs";
import f from "./getServiceIntervalTimeSpanMoment.mjs";
function S(r, n, i = "00:00:00") {
  const m = a(), e = o(i), s = o(n.duration), t = f(r, n.from);
  t.add(s);
  const u = p(
    e.hours,
    e.minutes
  );
  return t.diff(m, "minute") < u && t.subtract(e), t;
}
export {
  S as default
};
